import { FormControl, TextField, Typography } from '@mui/material';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import dayjs, { Dayjs } from 'dayjs';
import { DateTime } from 'luxon';
import { useContext, useEffect, useState } from 'react';

import { AdvancedFilterContext } from '../../AdvancedFilterContext';
import { FilterComponentGeneralInterface } from '../FilterComponent';

export interface DateRangeFilterProps extends FilterComponentGeneralInterface {
    // parseValue: (value: string | undefined) => DateTime;
}

const parseDefaultDate = (date?: string): DateTime | undefined => {
    if (!date) {
        return;
    }

    const jsDate = new Date(date);
    if (jsDate.toString() === 'Invalid Date') {
        return;
    }

    return DateTime.fromJSDate(jsDate);
};

// eslint-disable-next-line
export const DateRangeInput = <T,>({ onFilterFunction, field }: DateRangeFilterProps) => {
    const { defaultFiltersValue } = useContext(AdvancedFilterContext);
    // @ts-ignore
    const defaultStartDate = defaultFiltersValue?.[field]?.startDate;
    // @ts-ignore
    const defaultEndDate = defaultFiltersValue?.[field]?.endDate;

    const [startDate, setStartDate] = useState<DateTime | undefined>(parseDefaultDate(defaultStartDate));
    const [endDate, setEndDate] = useState<DateTime | undefined>(parseDefaultDate(defaultEndDate));

    useEffect(() => {
        onFilterFunction(field, field, () => {
            // Only return the filter if at least one date is selected
            if (startDate || endDate) {
                return {
                    [field]: {
                        startDate: startDate,
                        endDate: endDate,
                    },
                };
            }
            return {};
        });
    }, [startDate, endDate, field, onFilterFunction]);

    const onChangeStartDate = (value: Dayjs | null) => {
        if (value) {
            const result = DateTime.fromJSDate(value.toDate());
            setStartDate(result);
        } else {
            setStartDate(undefined);
        }
    };

    const onChangeEndDate = (value: Dayjs | null) => {
        if (value) {
            const result = DateTime.fromJSDate(value.toDate());
            setEndDate(result);
        } else {
            setEndDate(undefined);
        }
    };

    return (
        <LocalizationProvider dateAdapter={AdapterDayjs}>
            <div style={{ display: 'flex', alignItems: 'center', gap: '12px', width: '100%' }}>
                <FormControl size="small" sx={{ flex: 1, minWidth: '120px' }}>
                    <DatePicker
                        label="From"
                        value={startDate ? dayjs(startDate.toJSDate()) : null}
                        onChange={(date) => {
                            onChangeStartDate(date);
                        }}
                        renderInput={(params) => <TextField {...params} size="small" />}
                    />
                </FormControl>
                <Typography variant="body2" sx={{ flexShrink: 0, px: 1 }}>
                    to
                </Typography>
                <FormControl size="small" sx={{ flex: 1, minWidth: '120px' }}>
                    <DatePicker
                        label="To"
                        value={endDate ? dayjs(endDate.toJSDate()) : null}
                        onChange={(date) => {
                            onChangeEndDate(date);
                        }}
                        renderInput={(params) => <TextField {...params} size="small" />}
                    />
                </FormControl>
            </div>
        </LocalizationProvider>
    );
};
